module.exports.HOUR = new Array(24 + 1).join('0').split('');
module.exports.TWELVE_HOURS = new Array(12 + 1).join('0').split('');
module.exports.MINUTES = new Array(60 + 1).join('0').split('');
